import { useState, useEffect, useCallback , React} from "react";
import { Helmet } from "react-helmet-async";
import toast from "react-hot-toast";
import {
  Box,
  Button,
  Grid,
  Typography,
  LinearProgress,
  Select,
  MenuItem
} from "@material-ui/core";


import ReactGherkinEditor from "@smartbear/react-gherkin-editor";
// import ReactGherkinEditor from "../../react-gherkin-editor";
import SaveIcon from "@material-ui/icons/Save";
import CancelIcon from "@material-ui/icons/Cancel";
import DeleteIcon from "@material-ui/icons/Delete";
import { Link as RouterLink, useLocation, useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import useMounted from "../../hooks/useMounted";
import { Auth } from "aws-amplify";

import RunIcon from "@material-ui/icons/ArrowRight";


import { featuresApi } from "../../api/features";

// import FeaturesSidebar from "../../components/connect/feature/FeaturesSidebar";
// import { projectsApi } from "../../api/projects";
// import config from "../../config";

import CustomizedTreeView from "../../components/ContactFlow";
import TestLogs from "../../components/TestLogs";
import eventBus from "../../EventBus";

const initialValueConst = `Feature: Credit Cards Transactions
  I want to get my credit card statements
  So I can see my spendings

  Scenario: Welcome message
    Given I'm a customer of NorthCode banking
    When I call my bank 
    Then I hear "welcome to CC menu"

  Scenario: Email the last statement
    # some coments here 
    Given I'm a customer of NorthCode banking
    And I'm in the Credit Cards menu
    When I say "statements"
    Then I get my last statement as an email
    And I hear "your statement has been emailed to you"`;

const steps = [
  'I say "talk here"',
  'I press "123#"',
  'I wait "10" seconds',
  'I hear "listen"',
];

// TODO read it from parameter ...
// const URL = 'wss://2s313wpgia.execute-api.us-east-1.amazonaws.com/live'

const FeaturePage = (props) => {
  const { parentCallback, ...other } = props;
  let params = useParams();
  const mounted = useMounted();
  const navigate = useNavigate();
  const [run, setRun] = useState("");
  const [loading, setLoading] = useState(false);
  let featureContent = "";

  const [initialContent, setInitialContent] = useState("Please select a scenario... ");
  const [featureName, setFeatureName] = useState("New Feature");
  const [featureId, setFeatureId] = useState(params.featureId);
  const [projectId, setProjectId] = useState("");
  const [showRun, setShowRun] = useState(false);
  const [scenarioIds, setScenarioIds] = useState([]);
  const [showGutter, setShowGutter] = useState(true);

  const [provider, setProvider] = useState("none");


  console.log("FeaturePage params:" + JSON.stringify(params));
  console.log(
    "FeaturePage project:" + window.location.href.split("features/project/")[1]
  );


  var defaultOptions = {
    fontFamily: [
        "'SFMono-Medium'",
        "'SF Mono'",
        "'Segoe UI Mono'",
        "'Roboto Mono'",
        "'Ubuntu Mono'",
        'Menlo',
        'Consolas',
        'Courier',
        'monospace'
    ].join(', '),
    enableBasicAutocompletion: true,
    enableLiveAutocompletion: true,
    showLineNumbers: true,
    displayIndentGuides: false,
    tabSize: 2
};

  useEffect(() => {
    try {
      eventBus.on("newExecutionLog", (data) => {
        console.log("new exec starts : " + data);
        // clear the gutter TODO cannot re-run react SucessTooltip won't work for re-run! 
        let index = 0
        for (let div_lines of document.getElementsByClassName("ace_gutter-cell")) {
          div_lines.innerHTML = ++index + '<span style="display: none;"></span>'
          div_lines.style.color='black';
        }
      });
    } catch (err) {
      console.error(err);
    }
  }, [eventBus.on]);


  const getFeature = useCallback(
    async (fId) => {
      try {
        // initial FeatureId
        console.log("FeaturePage ... init ......" + fId);
        if (fId) {
          if ("new" == fId) {
            setInitialContent(initialValueConst);

            setShowRun(false);
          } else {
            // TODO load init value from DB !!!!
            console.log("loading feature : " + fId);
            const feature = await featuresApi.getFeature(fId);
            setInitialContent(atob(feature.content));
            //console.log('featureName : .......' + feature.featureName);
            setFeatureName(feature.featureName);
            console.log("featureName:", featureName);
            setProjectId(feature.projectId);
            setScenarioIds(feature.scenarios);
            console.log("scenarioIds:", scenarioIds);
            setShowRun(true);
          }
        }
      } catch (err) {
        console.error(err);
      }
    },
    [mounted]
  );

  const save = async () => {
    const user = await Auth.currentAuthenticatedUser({
      bypassCache: false, // Optional, By default is false. If set to true, this call will send a request to Cognito to get the latest user data
    });
    if ('' === featureContent){
      toast.success('no change to save');
      return
    }

    const newFeature = {
      projectId: params.projectId,
      featureContent: btoa(featureContent),
      featureId: featureId,
      userId: user.username,
    };
    const newFeatureId = await featuresApi.saveFeature(newFeature);

    console.log("new newFeatureId : " + newFeatureId);
    // props.parentCallback();
    const data = await featuresApi.getFeature(newFeatureId);
    // forward ..
    let toPath =
      "/features/project/" + params.projectId + "/feature/" + newFeatureId;
    navigate(toPath, {
      state: {
        test: "test value",
      },
    });
    setFeatureName(data.featureName);
    setFeatureId(newFeatureId);
    setInitialContent(featureContent);
    // nothing works! just reload the page for time being
    window.location.reload();
  };

  const runAll = () => {
    var data = featuresApi.runFeature(featureId, scenarioIds);
    setRun(data);
    if (!loading) {
      //setSuccess(false);
      setLoading(true);
    }
    console.log("run", run);
  };

  const handleStop = () => {
    setLoading(false);
    console.log("run", run);
  };

  const onValueChange = (newValue) => {
    //alert(props.parentCallback)
    featureContent = newValue;
  };

  const autoCompleteFunction = async (_keyword, text) => {
    const matches = steps.filter((step) => step.startsWith(text));

    const completions = matches.map((match) => ({
      caption: match,
      value: match,
      score: Math.floor(Math.random() * Math.floor(100)),
      meta: "Step",
    }));

    return completions;
  };

  if (mounted) {
    console.log("mounted........");
    if (params.featureId != featureId) {
      console.log("new feature id is : " + params.featureId);
      setFeatureId(params.featureId);
      getFeature(params.featureId);
    }
    //getMockMessages() // delete later on
    // setFeatureId(params.featureId);
    // setFeatureId(params.featureId);
    // getFeature(params.featureId);
  } else {
    console.log("not mounted........");
  }

  useEffect(() => {
    console.log("useEffect...");
    // setWs(new WebSocket(URL + '?token=' + token));
    setFeatureId(params.featureId);
    getFeature(params.featureId);
  }, [

  ]);

  if (params.featureId) {
    return (
      <>
        <Helmet>
          <title>Features... </title>
        </Helmet>

        <Box
          sx={{
            backgroundColor: "background.default",
            minHeight: "1%",
            py: 2,
            px: 2,
          }}
        >
          <Grid container justifyContent="space-between" spacing={1}>
            <Grid item xs={12}>
              <Button
                color="primary"
                onClick={save}
                startIcon={<SaveIcon fontSize="small" />}
                sx={{ m: 1 }}
                variant="contained"
              >
                Save
              </Button>

              {!showRun ? (
                <Button
                  color="primary"
                  component={RouterLink}
                  to={"/features/project/" + projectId}
                  startIcon={<CancelIcon fontSize="small" />}
                  sx={{ m: 1 }}
                  variant="contained"
                >
                  Cancel
                </Button>
              ) : (
                ""
              )}

              {showRun ? (
                <Button
                  color="primary"
                  component={RouterLink}
                  to={"/features/project/" + projectId}
                  startIcon={<DeleteIcon fontSize="small" />}
                  sx={{ m: 1 }}
                  variant="contained"
                >
                  Delete
                </Button>
              ) : (
                ""
              )}

              {/* {showRun ? (
                <Button
                  onClick={runAll}
                  sx={{
                    color: "green",
                    "&:hover": {
                      background: "#e6ffe6",
                    },
                  }}
                >
                  Run all scenarios
                  <RunIcon fontSize="medium" />
                </Button>
              ) : (
                ""
              )} */}

              {loading ? (
                <Button
                  onClick={handleStop}
                  sx={{
                    color: "green",
                    "&:hover": {
                      background: "#e6ffe6",
                    },
                  }}
                >
                  Stop the run
                  <RunIcon fontSize="medium" />
                </Button>
              ) : (
                ""
              )}
            </Grid>
            {loading ? (
              <Grid item xs={12}>
                <LinearProgress
                  color="success"
                  variant="buffer"
                  value="3"
                  valueBuffer="5"
                />
              </Grid>
            ) : (
              ""
            )}
            <Grid item xs={8}>
              <Typography color="textPrimary" variant="h5">
                Feature : {featureName}
              </Typography>
            </Grid>
            <Grid item xs={4}>
              <Typography color="textPrimary" variant="h5">
                Provider :
                <Select
                  value={provider}
                  onChange={(event) => setProvider(event.target.value)}
                >
                  <MenuItem value="none">Please select</MenuItem>
                  <MenuItem value="amazon">Amazon Connect</MenuItem>
                  <MenuItem value="genesys">Genesys</MenuItem>
                  <MenuItem value="avaya">Avaya</MenuItem>
                </Select>
              </Typography>
            </Grid>
            <Grid item xs={8}>
              <ReactGherkinEditor
                initialValue={initialContent}
                onChange={onValueChange}
                autoCompleteFunction={autoCompleteFunction}
                language="en"
                theme="cucumber"
                showGutter={true}
                activateLinter={true}
                highlightActiveLine={true}
                hideToolbar={true}
                autoFocus= {true}
                initialHeight={400}
                mode="gherkin_i18n"
                fontSize={14}
                width="100%"
                showPrintMargin={true}
                setOptions={defaultOptions}
              />

              <Box>
                Scenario execution logs
                <TestLogs/>
              </Box>
            </Grid>
            {/* <Grid item xs={4}>
              {connectMessages.reverse().map((message, index) => (
                <Box sx={{ p: 1 }}>
                  <Accordion>
                    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                      {[
                        "Disconnect",
                        "TransferToFlow",
                        "TransferContactToQueue",
                        "TransferParticipantToThirdParty",
                      ].includes(message.ContactFlowModuleType) ? (
                        <Typography sx={{ color: "red" }}>
                          {message.ContactFlowModuleType}
                        </Typography>
                      ) : (
                        <Typography sx={{ color: "green" }}>
                          {message.ContactFlowModuleType}
                        </Typography>
                      )}
                    </AccordionSummary>
                    <AccordionDetails>
                      <Paper variant="outlined" sx={{ width: 500 }}>
                        <pre style={{ whiteSpace: "pre-wrap" }}>
                          {JSON.stringify(message, null, 2)}
                        </pre>
                      </Paper>
                    </AccordionDetails>
                  </Accordion>
                </Box>
              ))}
            </Grid> */}

            <Grid item xs={4} >

            {[
              "amazon"
            ].includes(provider) ? (
              
              <CustomizedTreeView key="0"/>
       
            ) : (
              <Typography color="green" variant="h12">
              Please select the provider
            </Typography>
            )}

            

              
            </Grid>
          </Grid>
        </Box>
      </>
    );
  } else {
    return (
      <>
        <Helmet>
          <title>Features... </title>
        </Helmet>

        <Box
          sx={{
            backgroundColor: "background.default",
            minHeight: "1%",
            py: 1,
          }}
        >
          <Typography color="textPrimary" variant="h5">
            Please select a feature
          </Typography>
        </Box>
      </>
    );
  }
};

export default FeaturePage;
